/**
 * @file: Group items by a key, in the order the keys first appear.
 *
 * Four places grouped rows into a Map with the same reduce. One function
 * keeps the order rule in one place: the first item of a key decides where the
 * group stands. The playlist spread reads that order for its slots, and the
 * report reads it for its columns.
 */

/**
 * @param {Array} items - The items to group
 * @param {Function} keyOf - The key of one item
 * @returns {Map} One array per key, keys in order of first appearance
 */
function groupBy (items, keyOf) {
  return items.reduce((groups, item) => {
    const key = keyOf(item)
    const group = groups.get(key)
    if (group) {
      group.push(item)
    } else {
      groups.set(key, [item])
    }
    return groups
  }, new Map())
}

export { groupBy }
